import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PublicLayout } from "@/components/public/PublicLayout";

import Home from "@/pages/public/Home";
import Category from "@/pages/public/Category";
import Article from "@/pages/public/Article";
import Companies from "@/pages/public/Companies";
import Company from "@/pages/public/Company";
import Authors from "@/pages/public/Authors";
import Author from "@/pages/public/Author";
import NewsletterPage from "@/pages/public/NewsletterPage";
import Unsubscribe from "@/pages/public/Unsubscribe";
import Advertise from "@/pages/public/Advertise";
import Contact from "@/pages/public/Contact";
import StaticPage from "@/pages/public/StaticPage";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Articles from "@/pages/admin/Articles";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import Candidates from "@/pages/admin/Candidates";
import CandidateDetail from "@/pages/admin/CandidateDetail";
import AIDesk from "@/pages/admin/AIDesk";
import Sources from "@/pages/admin/Sources";
import CompaniesAdmin from "@/pages/admin/CompaniesAdmin";
import NewsletterAdmin from "@/pages/admin/NewsletterAdmin";
import Sponsored from "@/pages/admin/Sponsored";
import Settings from "@/pages/admin/Settings";
import Calendar from "@/pages/admin/Calendar";
import Analytics from "@/pages/admin/Analytics";

const CATEGORY_SLUGS = ["fintech","payments","banking","cards","infrastructure","digital-assets","regulation","companies","insights","latest"];

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-admbg flex items-center justify-center text-admtext2">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function Public({ children }) {
  return <PublicLayout>{children}</PublicLayout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          {/* Admin */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admin/articles" element={<Protected><Articles /></Protected>} />
          <Route path="/admin/articles/:id" element={<Protected><ArticleEditor /></Protected>} />
          <Route path="/admin/candidates" element={<Protected><Candidates /></Protected>} />
          <Route path="/admin/candidates/:id" element={<Protected><CandidateDetail /></Protected>} />
          <Route path="/admin/ai-desk" element={<Protected><AIDesk /></Protected>} />
          <Route path="/admin/analytics" element={<Protected><Analytics /></Protected>} />
          <Route path="/admin/calendar" element={<Protected><Calendar /></Protected>} />
          <Route path="/admin/companies" element={<Protected><CompaniesAdmin /></Protected>} />
          <Route path="/admin/sources" element={<Protected><Sources /></Protected>} />
          <Route path="/admin/newsletter" element={<Protected><NewsletterAdmin /></Protected>} />
          <Route path="/admin/sponsored" element={<Protected><Sponsored /></Protected>} />
          <Route path="/admin/settings" element={<Protected><Settings /></Protected>} />

          {/* Public */}
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/companies" element={<Public><Companies /></Public>} />
          <Route path="/companies/:slug" element={<Public><Company /></Public>} />
          <Route path="/authors" element={<Public><Authors /></Public>} />
          <Route path="/authors/:slug" element={<Public><Author /></Public>} />
          <Route path="/newsletter" element={<Public><NewsletterPage /></Public>} />
          <Route path="/unsubscribe" element={<Public><Unsubscribe /></Public>} />
          <Route path="/advertise" element={<Public><Advertise /></Public>} />
          <Route path="/contact" element={<Public><Contact /></Public>} />
          <Route path="/about" element={<Public><StaticPage slug="about" /></Public>} />
          <Route path="/editorial-policy" element={<Public><StaticPage slug="editorial-policy" /></Public>} />
          <Route path="/corrections-policy" element={<Public><StaticPage slug="corrections-policy" /></Public>} />
          <Route path="/privacy-policy" element={<Public><StaticPage slug="privacy-policy" /></Public>} />
          <Route path="/terms" element={<Public><StaticPage slug="terms" /></Public>} />
          <Route path="/:category" element={<Public><Category /></Public>} />
          <Route path="/:category/:slug" element={<Public><Article /></Public>} />
          <Route path="*" element={<Public><Home /></Public>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
